// eslint-disable-next-line @typescript-eslint/no-unused-vars
interface String {
  trimChar(char: string): string;
}

String.prototype.trimChar = function (char) {
  return this.replace(new RegExp(`^${char}+|${char}+$`, 'g'), '');
};
